import React from 'react'
import { Text } from '../Text/Text'
import { Stack } from '../Stack/Stack'
import { Box } from '../Box/Box'

export interface AccordionGroupProps {
  title?: string
  children: React.ReactNode[] | React.ReactNode
}
export const AccordionGroup: React.FC<AccordionGroupProps> = ({ title, children }) => {
  return (
    <Stack space="m">
      {title && (
        <Box marginX="m">
          <Text size="bigger" weight="fat">
            {title}
          </Text>
        </Box>
      )}
      {children}
    </Stack>
  )
}
